import { gql } from '@fdc/__generated__';

export const SAVE_SHOPPING_LIST_FREE_TEXT_FRAGMENT = gql(/* GraphQL */ `
  fragment SaveShoppingListFreeTextFields on FreeTextPayload {
    id
    referenceId
    text
    timestamp
  }
`);

export const SAVE_SHOPPING_LIST_PRODUCT_FRAGMENT = gql(/* GraphQL */ `
  fragment SaveShoppingListProductFields on ProductPayload {
    id
    referenceId
    articleNumber
    variantKey
    quantity
    timestamp
  }
`);

export const SAVE_SHOPPING_LIST = gql(/* GraphQL */ `
  mutation SaveList($input: SaveListInput!) {
    saveList(input: $input) {
      id
      referenceId
      name
      result
      action
      message
      errors {
        message
        code
      }
      freeTexts {
        ...SaveShoppingListFreeTextFields
      }
      products {
        ...SaveShoppingListProductFields
      }
    }
  }
`);
